import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import {ActionTypes} from '../constants/ErrorHandlerConstants';

const CHANGE_EVENT = 'change';

let _correlationId;

class ErrorHandlerStoreClass extends EventEmitter {
    constructor() {
        super();
    }
    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }
    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }
    emitChange() {
        return this.emit(CHANGE_EVENT);
    }
    getStore() {
        return {
            correlationId: _correlationId ? _correlationId : window.NOA.correlationId
        };
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ErrorHandlerStore = new ErrorHandlerStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ErrorHandlerStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ActionTypes.ERROR_HANDLED:
            _correlationId = action.correlationId;
            break;

        default:
            return true;
    }

    ErrorHandlerStore.emitChange();
    return true;
});

export default ErrorHandlerStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ErrorHandlerStore.js